import { render, staticRenderFns } from "./MedicalQualificationsForm.vue?vue&type=template&id=63e37364&scoped=true"
import script from "./MedicalQualificationsForm.vue?vue&type=script&lang=js"
export * from "./MedicalQualificationsForm.vue?vue&type=script&lang=js"
import style0 from "./MedicalQualificationsForm.vue?vue&type=style&index=0&id=63e37364&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e37364",
  null
  
)

export default component.exports